<i18n>
{
    "ru": {
        "footer": "Слишком часто видите эту страницу?",
        "feedback": "Напишите нам!",
        "submit": "Подтвердить",
        "text": "Мы заметили подозрительную активность с вашей стороны. Пожалуйста, подтвердите, что вы не робот.",
        "meta": {
            "title": "Aromo"
        }
    }
}
</i18n>

<template>
    <div class="app-monitoring-block">
        <!-- eslint-disable-next-line -->
        <svg class="app-monitoring-block__logo" width="156" height="26" viewBox="0 0 91 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <!-- eslint-disable-next-line -->
            <path fill-rule="evenodd" clip-rule="evenodd" d="M89.02 12.918c-1.326 1.305-3.132 1.957-5.418 1.957-1.496 0-2.794-.293-3.895-.877a5.96 5.96 0 0 1-2.532-2.553c-.588-1.116-.881-2.437-.881-3.96 0-1.567.293-2.908.881-4.025A6.058 6.058 0 0 1 79.707.892C80.808.297 82.107 0 83.602 0c1.538 0 2.858.297 3.959.892a6.166 6.166 0 0 1 2.548 2.568c.598 1.117.897 2.458.897 4.024 0 2.317-.662 4.129-1.986 5.434Zm-2.26-9.082c-.695-.846-1.748-1.268-3.158-1.268-1.346 0-2.367.422-3.062 1.268-.694.845-1.04 2.062-1.04 3.648 0 1.565.346 2.766 1.04 3.601.695.836 1.716 1.253 3.062 1.253 1.41 0 2.463-.417 3.158-1.253.694-.835 1.04-2.036 1.04-3.6 0-1.587-.346-2.804-1.04-3.65Zm-19.188 8h1.314v-5.73c0-1.253-.214-2.14-.64-2.662-.428-.522-1.155-.783-2.18-.783-.556 0-1.127.1-1.715.298-.588.199-1.053.454-1.394.767v8.11h1.314v2.506h-5.898v-2.505h1.346V6.106c0-1.253-.208-2.14-.625-2.662-.417-.522-1.138-.783-2.163-.783-.556 0-1.128.1-1.715.298-.59.199-1.064.454-1.427.767v8.11h1.346v2.506h-7.244v-2.505h2.66V3.632l-3.044-.97.833-2.506 4.455 1.44A7.572 7.572 0 0 1 54.96.423 7.15 7.15 0 0 1 57.347 0c.962 0 1.822.146 2.58.438.759.293 1.373.72 1.843 1.284.598-.502 1.315-.913 2.148-1.237A6.939 6.939 0 0 1 66.45 0c1.987 0 3.424.454 4.31 1.361.887.91 1.33 2.386 1.33 4.432v6.044h2.726v2.505h-7.245v-2.505Zm-28.816 3.039c-1.496 0-2.794-.293-3.895-.877a5.96 5.96 0 0 1-2.532-2.553c-.588-1.116-.881-2.437-.881-3.96 0-1.567.293-2.908.881-4.025A6.058 6.058 0 0 1 34.861.892C35.962.297 37.261 0 38.756 0c1.538 0 2.858.297 3.959.892a6.167 6.167 0 0 1 2.548 2.568c.598 1.117.897 2.458.897 4.024 0 2.317-.662 4.129-1.986 5.434-1.326 1.305-3.132 1.957-5.418 1.957Zm3.158-11.04c-.695-.845-1.748-1.267-3.158-1.267-1.346 0-2.367.422-3.062 1.268-.694.845-1.04 2.062-1.04 3.648 0 1.565.346 2.766 1.04 3.601.695.836 1.716 1.253 3.062 1.253 1.41 0 2.463-.417 3.158-1.253.694-.835 1.04-2.036 1.04-3.6 0-1.587-.346-2.804-1.04-3.65ZM26.996 2.819a9.046 9.046 0 0 0-2.02.344 6.056 6.056 0 0 0-1.666.752l-.033 7.923h3.142v2.505h-9.04v-2.505h2.693V3.694l-3.077-1.001.865-2.537 4.552 1.503A9.948 9.948 0 0 1 24.96.454a8.922 8.922 0 0 1 2.58-.392c.79 0 1.421.094 1.892.282l.545 3.633-2.66.564-.321-1.723ZM10.45 13.591c-1.453.855-2.97 1.284-4.552 1.284-1.923 0-3.381-.367-4.375-1.097C.53 13.048.022 11.983 0 10.584c-.021-2.86 1.87-4.29 5.674-4.29l3.782.032c0-1.316-.262-2.292-.785-2.929-.524-.636-1.256-.955-2.196-.955-.492 0-.961.031-1.41.094a8.15 8.15 0 0 0-1.282.282l-.321 1.628-2.66-.407.577-3.131A16.645 16.645 0 0 1 3.91.235 14.16 14.16 0 0 1 6.476 0c2.03 0 3.574.527 4.632 1.581 1.058 1.055 1.587 2.605 1.587 4.65v5.293l2.82.908L14.682 15l-4.231-1.41Zm-.994-5.074H5.77c-.79 0-1.4.172-1.827.517-.428.345-.641.841-.641 1.488 0 1.294.908 1.941 2.725 1.941 1.282 0 2.425-.333 3.43-1.002V8.517Z" fill="#141414"/>
        </svg>
        <div class="app-monitoring-block__content">
            <div class="app-monitoring-block__content-message">{{ text }}</div>
            <div class="app-monitoring-block__content-container" v-if="reCaptchaPublicKey">
                <div class="app-monitoring-block__content-recaptcha">
                    <client-only>
                        <ReCaptcha
                            ref="reCaptcha"
                            cid="reCaptcha"
                            :monitoring-entry-id="monitoringEntryId"
                            :public-key="reCaptchaPublicKey"
                            @onVerify="onReCaptchaVerify"
                            @onReady="onReCaptchaReady"/>
                    </client-only>
                </div>
                <ButtonBase
                    @click.native="submit"
                    :disabled="isButtonDisabled"
                    :data-loading="isButtonLoading"
                    class="app-monitoring-block__content-button">
                    {{ $t('submit') }}
                </ButtonBase>
            </div>
        </div>
        <div class="app-monitoring-block__footer" v-if="reCaptchaPublicKey">
            <p>{{ $t('footer') }}</p>
            <p>
                <span class="app-monitoring-block__footer-link" @click="onFeedbackClick">
                    {{ $t('feedback') }}
                </span>
            </p>
        </div>
    </div>
</template>

<script>
import get from 'lodash/get';
import ButtonBase from '@/components/ui/buttons/ButtonBase';
import ReCaptcha from '@/components/ui/ReCaptcha';

export default {
    name: 'AppMonitoringBlock',
    components: {
        ButtonBase,
        ReCaptcha
    },
    props: {
        monitoringData: {
            type: Object,
            default: () => {}
        }
    },
    data(){
        return{
            isButtonDisabled: true,
            isButtonLoading: true
        }
    },
    computed: {
        text(){
            return get(this.monitoringData, 'message', this.$t('text'));
        },
        reCaptchaPublicKey(){
            return get(this.monitoringData, 'reCaptcha.publicKey', null);
        },
        monitoringEntryId(){
            return get(this.monitoringData, 'data.entryId');
        }
    },
    // created(context) {
    //     if (this.monitoringData.status) {
    //         // this.$nuxt.error({statusCode: this.monitoringData.status});
    //     }
    // },
    methods: {
        submit(){
            this.$refs.reCaptcha.execute();
        },
        onFeedbackClick(){
            this.showPopup('feedback', {
                reCaptchaPublicKey: this.reCaptchaPublicKey,
                monitoringEntryId: get(this.monitoringData, 'data.entryId')
            });
        },
        onReCaptchaVerify(res){
            if(res){
                this.isButtonLoading = true;
                this.isButtonDisabled = true;
                this.$store.dispatch('monitoringResponse', null);
                this.$nuxt.refresh();
                this.$router.go();
            }else{
                this.isButtonLoading = false;
                this.isButtonDisabled = false;
            }
        },
        onReCaptchaReady(){
            this.isButtonLoading = false;
            this.isButtonDisabled = false;
        }
    },
    head() {;
        return {
            title: this.$t('meta.title'),
            meta: [
                {
                    hid: 'robots',
                    name: 'robots',
                    content: 'noindex, nofollow'
                }
            ]
        };
    }
}
</script>

<style lang="less">
.app-monitoring-block{
    text-align: center;
    min-height: 100vh;
    background-color: @color-white;
    z-index: 109;
    padding: rem(120) 0;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

    &__logo{
        width: rem(156);
        height: rem(26);
        position: absolute;
        top: rem(56);
        left: auto;
        right: auto;
        margin: 0 auto;
    }

    &__content{
        max-width: rem(888);
        margin: 0 auto rem(40);
        padding: rem(100) rem(116);
        flex: 1;
        box-sizing: border-box;
        background-color: @color-bg-gray-minor;

        &-message{
            font-weight: 500;
            font-size: rem(18);
            line-height: rem(27);
        }

        &-button{
            width: rem(220);
            margin: rem(40) auto 0;
            
            &[disabled]{
                background-color: @color-white;
            }

            &[data-loading="true"]{
                pointer-events: none;
                background-color: @color-white;
                border-color: @color-gray-white;

                &::after{
                    background: url('~static/img/loading-btn-transparent.gif') no-repeat 50%;
                    background-size: rem(24);
                    border: rem(1) solid transparent;
                }
            }
        }

        &-container{
            margin-top: rem(24);
        }

        // &-recaptcha{
        //     min-height: rem(78);
        // }
    }

    &__footer{
        position: absolute;
        bottom: rem(40);
        left: 0;
        right: 0;

        p{
            margin-bottom: rem(4);

            &:last-child{
                margin-bottom: 0;
            }
        }

        &-link{
            cursor: pointer;
            color: @color-primary;

            .hover({
                color: @color-black;
            });
        }
    }

    @{mobile} & {
        padding-left: rem(20);
        padding-right: rem(20);

        &__content{
            padding: rem(24) rem(24) rem(32);

            &-button{
                margin-top: rem(32);
            }
        }
    }
}
</style>